import { AppDispatch } from '@/app/store';
import { Box, Button, Paper, Slide, Stack, Typography, useMediaQuery } from '@mui/material';
import { NavigateFunction, useNavigate } from 'react-router-dom';
import { ROUTE_COOKIE_CONSENT } from '@/app/routes';
import { Theme } from '@mui/material/styles';
import { TypographyLink } from './TypographyLink';
import { acceptConsent, getCookieConsentAccepted } from '@/services/cookieConsentSlice';
import { getAuthenticated } from '@/services/authSlice';
import { useAppDispatch, useAppSelector } from '@/app/hooks';
import React, { FC, useEffect, useState } from 'react';

const CookieConsentBanner: FC = () => {
  const navigate: NavigateFunction = useNavigate();
  const dispatch: AppDispatch = useAppDispatch();
  const isMobile: boolean = useMediaQuery((theme: Theme): string => theme.breakpoints.down('sm'));

  const isAuthenticated: boolean = useAppSelector(getAuthenticated);
  const isAccepted: boolean = useAppSelector(getCookieConsentAccepted);

  const [isOpen, setOpen] = useState<boolean>(false);

  const handleAccept = (): void => {
    dispatch(acceptConsent());
  };

  const handleNavigateToConsentPage = (): void => {
    navigate(ROUTE_COOKIE_CONSENT);
  };

  useEffect(() => {
    if (isAuthenticated || isAccepted) {
      setOpen(false);
      return;
    }
    setOpen(true);
  }, [isAuthenticated, isAccepted]);

  return (
    <Slide direction={'up'} in={isOpen} mountOnEnter={true} unmountOnExit={true}>
      <Box
        sx={{
          display: 'flex',
          position: isMobile ? 'fixed' : 'sticky',
          bottom: isMobile ? '16px' : '24px',
          justifyContent: 'flex-end',
          zIndex: 9999,
          width: isMobile ? 'calc(100% - 32px)' : 'auto',
        }}>
        <Paper
          elevation={6}
          sx={{
            width: '100%',
            maxWidth: isMobile ? '100%' : (theme: Theme) => theme.spacing(75),
            borderRadius: (theme: Theme) => theme.spacing(1.5),
            padding: (theme: Theme) => theme.spacing(3),
          }}>
          <Stack
            direction={'column'}
            spacing={4}
            alignItems={isMobile ? 'stretch' : 'flex-end'}
            justifyContent={'space-between'}>
            <Box flex={1}>
              <Typography variant={isMobile ? 'body2' : 'body1'}>
                {
                  'Наш сайт использует файлы cookie, чтобы улучшить работу сайта, повысить его эффективность и удобство. '
                }
                <TypographyLink onClick={handleNavigateToConsentPage}>{'Подробнее'}</TypographyLink>
              </Typography>
            </Box>
            <Button
              variant={'contained'}
              onClick={handleAccept}
              sx={{
                minWidth: isMobile ? '100%' : (theme: Theme) => theme.spacing(22.5),
              }}>
              {'Понятно'}
            </Button>
          </Stack>
        </Paper>
      </Box>
    </Slide>
  );
};

export { CookieConsentBanner };
